var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lot
    ? _c("div", [
        _vm._m(0),
        _c("div", { staticClass: "row" }, [
          _c("label", { staticClass: "d-inline mx-10 form-control-label" }, [
            _vm._v(" Issue "),
          ]),
          _c(
            "div",
            { staticClass: "d-inline mx-10" },
            [
              _c("DatePicker", {
                ref: "issue_date",
                attrs: {
                  "width-200px": "",
                  type: "datetime",
                  confirm: true,
                  placeholder: "n/a",
                  format: "DD/MM/YYYY HH:mm",
                  "value-type": "YYYY-MM-DD HH:mm",
                  disabled: _vm.disabled,
                },
                on: {
                  change: function ($event) {
                    return _vm.update("issue_date")
                  },
                },
                model: {
                  value: _vm.lot.issue_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.lot, "issue_date", $$v)
                  },
                  expression: "lot.issue_date",
                },
              }),
            ],
            1
          ),
          _c("label", { staticClass: "d-inline mx-10 form-control-label" }, [
            _vm._v(" Expire "),
          ]),
          _c(
            "div",
            { staticClass: "d-inline mx-10" },
            [
              _c("DatePicker", {
                ref: "expire_date",
                attrs: {
                  "width-200px": "",
                  type: "datetime",
                  confirm: true,
                  placeholder: "n/a",
                  format: "DD/MM/YYYY HH:mm",
                  "value-type": "YYYY-MM-DD HH:mm",
                  disabled: _vm.disabled,
                },
                on: {
                  change: function ($event) {
                    return _vm.update("expire_date")
                  },
                },
                model: {
                  value: _vm.lot.expire_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.lot, "expire_date", $$v)
                  },
                  expression: "lot.expire_date",
                },
              }),
              _c(
                "label",
                { staticClass: "d-inline mx-10 form-control-label" },
                [_vm._v(" (Expire date here will override Prize settings.) ")]
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "form-control-label" }, [
        _c("h4", [_vm._v("Prize Lot Date")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }